import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CATEGORIES } from "@/lib/api";

const DURATIONS = ["Satu Hari (One-day)", "Multi-hari (Multi-day)"];

export default function PlannerFields({ fields, setField, outLang, setOutLang }) {
  return (
    <div className="space-y-3 mb-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        <Select value={fields.category} onValueChange={(v) => setField("category", v)}>
          <SelectTrigger data-testid="planner-category-select" className="rounded-xl" aria-label="Kategori aksi">
            <SelectValue placeholder="Kategori Aksi" />
          </SelectTrigger>
          <SelectContent>{CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
        <Input data-testid="planner-beneficiaries-input" placeholder="Target Penerima Manfaat" aria-label="Target penerima manfaat"
          value={fields.beneficiaries} onChange={(e) => setField("beneficiaries", e.target.value)} className="rounded-xl" />
        <Input data-testid="planner-volunteers-input" type="number" min="0" placeholder="Relawan Tersedia (orang)" aria-label="Jumlah relawan tersedia"
          value={fields.volunteers} onChange={(e) => setField("volunteers", e.target.value)} className="rounded-xl" />
        <Select value={fields.duration} onValueChange={(v) => setField("duration", v)}>
          <SelectTrigger data-testid="planner-duration-select" className="rounded-xl" aria-label="Durasi kegiatan">
            <SelectValue placeholder="Durasi" />
          </SelectTrigger>
          <SelectContent>{DURATIONS.map((d) => <SelectItem key={d} value={d}>{d}</SelectItem>)}</SelectContent>
        </Select>
        <Input data-testid="planner-resources-input" placeholder="Sumber daya non-uang (tempat, alat, jejaring)" aria-label="Sumber daya non-uang yang sudah ada"
          value={fields.resources} onChange={(e) => setField("resources", e.target.value)} className="rounded-xl col-span-2 lg:col-span-1" />
        <div className="flex items-center gap-1.5" role="group" aria-label="Bahasa output playbook">
          <span className="text-xs font-bold text-slate-500 shrink-0">Output:</span>
          {[["id", "🇮🇩 Bahasa Indonesia"], ["en", "🇬🇧 English"]].map(([code, label]) => (
            <button
              key={code}
              data-testid={`output-lang-${code}`}
              onClick={() => setOutLang(code)}
              aria-pressed={outLang === code}
              className={`text-xs font-bold px-3 py-2 rounded-full border-2 transition-colors ${
                outLang === code ? "border-emerald-600 bg-emerald-50 text-emerald-800" : "border-slate-200 text-slate-500 hover:border-emerald-300"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
